import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import { Check } from '@material-ui/icons'
import { IconButton } from '@material-ui/core'

const Checkbox = ({
  classes,
  label,
  formik,
  fieldName,
  isDisabled,
  otherStyles,
  isChecked, // оставляем для внешней логики
  value, // новое: значение, если нет formik
  setValue, // новое: setter, если нет formik
  ...props
}) => {
  const handleClick = () => {
    if (isDisabled) return

    if (formik && fieldName) {
      // если используется formik
      formik.setFieldValue(fieldName, !formik.values[fieldName])
    } else if (typeof setValue === 'function') {
      // если используется value/setValue
      setValue(!value)
    }
  }

  const checked = formik
    ? formik.values[fieldName]
    : isChecked ?? value ?? false

  return (
    <div className={classes.checkbox} style={{ ...otherStyles }}>
      <IconButton
        style={{ width: '1em', height: '1em' }}
        className={isDisabled ? classes.iconDisabled : classes.icon}
        onClick={handleClick}
        disabled={isDisabled}
        {...props}
      >
        {checked && <Check />}
      </IconButton>

      {label && (
        <p className={isDisabled ? classes.labelDisabled : classes.label}>
          {label}
        </p>
      )}
    </div>
  )
}

const styles = () => ({
  checkbox: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    border: `1px solid ${palette.blue}`,
    borderRadius: '0px',
    color: palette.blue
  },
  iconDisabled: {
    border: `1px solid ${palette.grey}`,
    borderRadius: '0px',
    color: palette.blue
  },
  label: {
    fontSize: '14px',
    margin: '0 15px'
  },
  labelDisabled: {
    fontSize: '14px',
    margin: '0 15px',
    color: palette.grey
  }
})

export default withStyles(styles)(Checkbox)
